import React from 'react'

const baseNormCache = {}

function calculateBaseNorm (normAtDefault, activeIndex) {
  if (typeof baseNormCache[normAtDefault + '.' + activeIndex] === 'undefined') {
    baseNormCache[normAtDefault + '.' + activeIndex] = Math.ceil(normAtDefault * (activeIndex / 100))
  }
  return baseNormCache[normAtDefault + '.' + activeIndex]
}

export default function useBaseNorm (normAtDefault, activeIndex) {
  return React.useMemo(() => {
    return calculateBaseNorm(normAtDefault, activeIndex)
  }, [normAtDefault, activeIndex])
}
